export const retirarMascara = valor => Number.parseFloat(valor?.replace('R', '').replace('$', '')?.replace(',', '.'));